import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Link } from "gatsby";
import Img1 from "../../../images/landing/web-development.webp";
import Img2 from "../../../images/landing/mobile-development.webp";
import Img3 from "../../../images/landing/Strategy.webp";
import Img4 from "../../../images/landing/staff-augmentation.webp";
import Img5 from "../../../images/landing/marketing.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import BannerForm from "../../components/bannerfrom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Servicesweb = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section class="services_web_lp p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="service_lp_main">
                <div className="lp_item_services services_center">
                  <h2>Our Services</h2>
                  <p>
                    We're all about making your ideas happen. Our goal is
                    simple: help brands use technology to create the change they
                    want. 
                  </p>
                  <p>
                    We're here to support businesses in becoming a part of the
                    digital revolution. Our solutions are straightforward and
                    designed to fit your unique goals.
                  </p>
                  <Link
                    to=""
                    className="lp_btn"
                    aria-label="TekRevol Contact"
                    onClick={handleShow}
                  >
                    Let’s Talk
                  </Link>
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="my-auto">
              <div className="service_lp_main">
                <Swiper
                  loop={true}
                  navigation={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  modules={[Navigation, Autoplay]}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 2,
                    },
                    1400: {
                      slidesPerView: 2,
                    },
                    1600: {
                      slidesPerView: 2,
                    },
                  }}
                  className="carousel_lp"
                >
                  <SwiperSlide>
                    <div className="lp_item_services">
                      <div className="lp_title">
                        <div className="lp_img">
                          <LazyLoadImage
                            src={Img1}
                            effect="blur"
                            alt="TekRevol"
                            className="img-fluid"
                          />
                        </div>
                        <div className="lp_tit">Web Development</div>
                      </div>
                      <div className="lp_web_content">
                        <p>
                          Crafting dynamic and responsive web applications that
                          elevate your online presence through cutting-edge
                          technology and design.
                        </p>
                        <ul>
                          <li>Custom Web Application Development</li>
                          <li>Website Design and Development</li>
                          <li>Web Portal Development</li>
                          <li>UI & UX Design</li>
                          <li>Ecommerce Development</li>
                          <li>CMS Development</li>
                          <li>Front-end Web Development</li>
                          <li>Back-end Web Development</li>
                          <li>DevOps & Cloud</li>
                          <li>Quality Assurance and Testing</li>
                        </ul>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="lp_item_services">
                      <div className="lp_title">
                        <div className="lp_img">
                          <LazyLoadImage
                            src={Img2}
                            effect="blur"
                            alt="TekRevol"
                            className="img-fluid"
                          />
                        </div>
                        <div className="lp_tit">Mobile App Development</div>
                      </div>
                      <div className="lp_web_content">
                        <p>
                          Transforming ideas into intuitive, high-performance
                          mobile experiences for seamless user engagement.
                        </p>
                        <ul>
                          <li>Android App Development</li>
                          <li>iOS App Development</li>
                          <li>UI & UX Design</li>
                          <li>UI & UX Design</li>
                          <li>Cross-Platform App Development</li>
                          <li>Game App Development</li>
                          <li>Quality Assurance and Testing</li>
                        </ul>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="lp_item_services">
                      <div className="lp_title">
                        <div className="lp_img">
                          <LazyLoadImage
                            src={Img3}
                            effect="blur"
                            alt="TekRevol"
                            className="img-fluid"
                          />
                        </div>
                        <div className="lp_tit">Strategy and Consulting</div>
                      </div>
                      <div className="lp_web_content">
                        <p>
                          Strategic insights guiding your digital journey,
                          ensuring success in the evolving web and app
                          development world.
                        </p>
                        <ul>
                          <li>Cloud Computing</li>
                          <li>CTO Consultancy</li>
                          <li>Emerging Technology</li>
                          <li>Digital Transformation</li>
                          <li>Digital Marketplace</li>
                          <li>Data Analytics</li>
                          <li>Digital Strategy</li>
                        </ul>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="lp_item_services">
                      <div className="lp_title">
                        <div className="lp_img">
                          <LazyLoadImage
                            src={Img4}
                            effect="blur"
                            alt="TekRevol"
                            className="img-fluid"
                          />
                        </div>
                        <div className="lp_tit">IT Staff Augmentation</div>
                      </div>
                      <div className="lp_web_content">
                        <p>
                          Boosting project efficiency with skilled professionals
                          seamlessly integrated into your team. We have hiring
                          models for:
                        </p>
                        <ul>
                          <li>Dedicated Teams</li>
                          <li>Individual Resources</li>
                          <li>Project Outsourcing</li>
                          <li>Digital Transformation</li>
                          <li>Flexible Team Scaling</li>
                          <li>Skilled Resource Provisioning</li>
                        </ul>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="lp_item_services">
                      <div className="lp_title">
                        <div className="lp_img">
                          <LazyLoadImage
                            src={Img5}
                            effect="blur"
                            alt="TekRevol"
                            className="img-fluid"
                          />
                        </div>
                        <div className="lp_tit">Marketing</div>
                      </div>
                      <div className="lp_web_content">
                        <p>
                          Once your website is live, we strategically promote it
                          through targeted marketing campaigns, leveraging
                          various channels to maximize visibility and
                          engagement.
                        </p>
                        <ul>
                          <li>Dedicated Teams</li>
                          <li>Individual Resources</li>
                          <li>Project Outsourcing</li>
                          <li>Digital Transformation</li>
                          <li>Flexible Team Scaling</li>
                          <li>Skilled Resource Provisioning</li>
                        </ul>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </>
  );
};

export default Servicesweb;
